export enum LoadingState {
  NotSent = 'NOT_SENT',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Error = 'ERROR',
}
